import { Button, Center } from "@chakra-ui/react"
import { useBrandedTranslation } from "../../../../../../common/hooks/useBrandedTranslation"

type Props = {
  handleLoadMore: () => void
  loadNumberOfItems: number
  label: string
}

const LoadMoreButton = ({ handleLoadMore, loadNumberOfItems, label }: Props) => {
  const { t } = useBrandedTranslation()
  return (
    <Center mt="8">
      <Button variant="primary" onClick={handleLoadMore}>
        {t(label, { count: loadNumberOfItems, n: loadNumberOfItems })}
      </Button>
    </Center>
  )
}

export default LoadMoreButton
